/////tsnocheck
import {
  HistoricalPosition,
  Position,
  SystemWatchlist,
} from '@oai-frontend-monorepo/types';
import { parseToken } from '@oai-frontend-monorepo/utils';
import createClient from '../create-client';
import { GetSystemListsResponse } from './responses/GetSystemListsResponse';
import { GetSystemListByIdParams } from './requests/get-system-list-by-id.params';
import { GetSystemListByIdResponse } from './responses/GetSystemListByIdResponse';
import { OpenPaperOrderParams } from './requests/OpenPaperOrderParams';
import { ClosePaperOrderParams } from './requests/ClosePaperOrderParams';
import { PaperPnlResponse } from './responses/PaperPnlResponse';

export class GatewayApiClient {
  private client: ReturnType<typeof createClient>;

  constructor(getToken?: () => Promise<string | undefined>) {
    this.client = createClient(``, getToken);
  }

  public async getPositionHistory(brokerageAccountNumber?: string) {
    const token = await this.client.token?.();
    // @ts-nocheck
    const parsed = parseToken(token);

    if (!parsed?.oai) {
      throw new Error('No OAI token found');
    }

    const accountType = !parsed.groups?.includes('Traders')
      ? 'PAPER'
      : 'TRADIER';

    // https://uat-gateway-api.herokuapp.com/positions/history?position_type=PAPER&account_id=f3b7a90e-4617-4328-a564-aae22648c361

    let res = await this.client.get<HistoricalPosition[]>(
      `/positions/history?account_id=${parsed.oai
      }&position_type=${accountType}${brokerageAccountNumber
        ? `&account_number=${brokerageAccountNumber}`
        : ''
      }`
    );

    if (res && accountType === 'PAPER') {
      res = res.filter((position) =>
        position.orders?.[0]?.legs.some((l) => l.type === 'PAPER')
      );
    }

    return res;
  }
  public async getPpaperPnl() {
    const res = await this.client.get<PaperPnlResponse>(
      '/positions/paper-historic-profit'
    );

    if (res === null) {
      return {
        accountId: '',
        profit: 0,
      };
    }

    return res;
  }

  public async placeOpenPaperOrder({
    limitPrice,
    quantity,
    timeInForce,
    legs,
    positionType,
    strategy,
    createdAt,
  }: OpenPaperOrderParams) {
    return this.client.post<string>('/positions/paper-order', {
      type: positionType,
      limitPrice,
      quantity,
      timeInForce,
      legs,
      strategy,
      createdAt,
    });
  }

  public async placeClosePaperOrder({
    limitPrice,
    quantity,
    timeInForce,
    legs,
    positionType,
    strategy,
    positionId,
  }: ClosePaperOrderParams) {
    return this.client.post<string>('/positions/paper-order', {
      type: positionType,
      limitPrice,
      quantity,
      timeInForce,
      legs: legs,
      strategy,
      positionId,
    });
  }

  public async splitPosition(positionId?: string) {
    return this.client.post<string>('/positions/split-fly', {
      target_position_id: positionId,
    });
  }

  public async combinePositions(positionIds?: string[]) {
    return this.client.post<string>('/positions/combine-positions', {
      source_position_ids: positionIds,
    });
  }

  public async getUnderlyingSymbolChanges() {
    return this.client.get<{ [key: string]: string; }>('/underlying');
  }

  public getSystemLists = async (): Promise<SystemWatchlist[]> => {
    const res = await this.client.get<GetSystemListsResponse>(
      `/watchlists?include_system_lists=true`
    );

    return res?.watchlists || [];
  };

  getSystemListById = async ({
    id,
    page,
    pageSize,
  }: GetSystemListByIdParams): Promise<GetSystemListByIdResponse> => {
    const res = await this.client.get<GetSystemListByIdResponse>(
      `/watchlists/${id}?page=${page}&pageSize=${pageSize}`
    );

    return res;
  };

  public async getPositions(brokerageAccountNumber?: string) {
    const token = await this.client.token?.();
    // @ts-nocheck
    const parsed = parseToken(token);

    if (!parsed?.oai) {
      throw new Error('No OAI token found');
    }

    const accountType = !parsed.groups?.includes('Traders')
      ? 'PAPER'
      : 'TRADIER';

    let res = await this.client.get<Position[]>(
      `/positions?account_id=${parsed.oai}&position_type=${accountType}${brokerageAccountNumber
        ? `&account_number=${brokerageAccountNumber}`
        : ''
      }`
    );

    if (res && accountType === 'PAPER') {
      res = res.filter((position) => position.positionType === 'PAPER');
    }

    return res;
  }

  public registerGetToken(
    baseUrl: string,
    getToken?: () => Promise<string | undefined>
  ) {
    this.client = createClient(baseUrl, getToken);

    return this;
  }
}

export default new GatewayApiClient();
